import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, User } from '../../services/user.service';
import { TemplateService } from '../../services/template.service';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from '../../services/notification.service';
import { ContractorService } from '../../services/contractor.service';
import { FileService } from '../../services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { PIDService } from '../../services/pid.service';
import { FormControl, FormArray, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FileTypeService } from '../../services/fileType.service';
import { map, startWith } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { SearchbarService } from '../../services/searchbar.service';

@Component({
  selector: 'nestas-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
  steps = [];
  me = new User();
  fileTypes = {
    display: [],
    all: []
  }
  templates = [];

  allContractors = [];
  profile;
  allRooms = [];
  allTypes = [];
  filteredTypes: Observable<User[]>[] = [];
  filteredRooms: Observable<User[]>[] = [];
  filteredContractors: Observable<User[]>[] = [];
  form: FormGroup;
  pid;
  fileDetails;
  currentFilter;
  showMineOnly = false; 

  newContractor = {
    name: '',
    email: '',
    phone: ''
  }

  constructor(private _templateService: TemplateService, private _router: Router, private _user: UserService,
    private _profile: ProfileService, private _contractorService: ContractorService, private _pidService: PIDService,
    private _notification: NotificationService, public translate: TranslateService, private formBuilder: FormBuilder,
    private _searchService: SearchbarService, public fileTypeService: FileTypeService,
    private _route: ActivatedRoute, private _fileService: FileService) {
    this.steps.push({ name: [translate.instant('TOOLBAR.STEP.TEMPLATE')], ref: ["template"] })
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      items: this.formBuilder.array([]),
      allSelected: false
    });

    if (!this._user.isLoggedIn()) {
      this._router.navigate([''], { queryParams: { redirect: 'template' } });
    } else {
      this._route.params.subscribe(params => {
        this.pid = params.pid;

        var proms = [];
        proms.push(this.fileTypeService.getMe());
        proms.push(this._profile.me());

        if (this.pid) {
          proms.push(this._fileService.getFromPID(params.pid));
        }

        combineLatest(proms).subscribe(ret => {
          this.allTypes = ret[0] as any[];
          this.profile = ret[1];
          if (ret.length > 2) {
            this.fileDetails = ret[2];
          }
          this.populateTable();
        });

      });
    }
  }

  hideUsedTemplates(ft) {
    return this.pid && this.fileDetails.filter(x => x.template).map(x => x.template).indexOf(ft._id) > -1;
  }

  hideCompanyTemplates(ft) {
    return this.showMineOnly && ft.profile.toString() != this.profile._id;
  }

  cancel(){
    let qp = { 'tabindex': '0' };
    return this._router.navigate(['pid', this.pid], { queryParams: qp });
  }

  filterTemplates(filter) {
    this.currentFilter = filter;
    var templates = { all: this.templates, display: [] };
    this._searchService.filter(templates, filter);

    let displayed = templates.display.map(x => x._id);
    this.templates.forEach(x => {
      if (x._id && displayed.indexOf(x._id) == -1) {
        x.hidden = true;
      } else {
        x.hidden = false;
      }
    })
  }

  typeAutocompleteFilter(list, val: string) {
    return list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) > -1);
  }

  roomAutocompleteFilter(list, val: string) {
    return list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) > -1);
  }

  contractorAutocompleteFilter(list, val: string) {
    return list.filter(option => ((option.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
      (option.email.toLowerCase().indexOf(val.toLowerCase()) > -1)));
  }

  nameChanged(event, i) {
    this.templates[i].changed = true;
    if (event.target.value && i == this.templates.length - 1) {
      this.addTemplate();
    }
  }

  valueChanged(i) {
    this.templates[i].changed = true;
  }

  formatContractor(c) {
    return c.name + ' (' + c.email + ')';
  }

  contractorId(contractor) {
    console.log(this.allContractors, this.allContractors.find);
    let c = this.allContractors.find(c => {
      return (this.formatContractor(c) == contractor);
    });

    return c && c._id || null;
  }

  saveTemplates() {
    this.templates.forEach((x, i) => {
      //console.log(i, x.name, x.deleted, x.changed);
      if (!x.deleted) {
        Object.assign(x, this.form.value.items[i]);
        if (x.contractor) {
          let c = this.contractorId(x.contractor);
          if (c) x.contractor = c;
        }
        if (this.profile.company && !x.company){
          x.company = this.profile.company;
          
        }
        console.log("company", x.company, this.profile, this.profile.company);
      }
    });

    this._templateService.updateTemplates(this.profile._id, this.templates.filter(x => x.changed || x.deleted))
      .subscribe(c => {
        this.templates = [];
        this.populateTable();
      });
  }

  addToPid() {
    let rooms = [];
    let proms = [];
    this.templates.forEach((x, i) => {
      if (this.form.value.items[i].selection) {
        let data = {
          name: x.name,
          type: x.type,
          description: x.description,
          room: x.room,
          template: x._id
        };
        if (x.contractor) {
          data['contractor'] = x.contractor._id;
        } else {
          data['contractor'] = -1;
        }

        proms.push(this._fileService.addFile(this.pid, data)
          .subscribe((ret: any) => {
            console.log("added file", ret);
          }));
        rooms.push(x.room);
      }
    });
    proms.push(this._pidService.addRooms(this.pid, rooms)
      .subscribe((ret: any) => {
        console.log("added rooms", ret);
      }));

    let qp = { 'tabindex': '0' };
    return Promise.all(proms).then(x => this._router.navigate(['pid', this.pid], { queryParams: qp }));
  }

  removeTemplate(i) {
    this.templates[i].deleted = true;
    this.templates[i].name = "";
  }

  addTemplate() {
    this.templates.push({ name: '', type: '', description: '', room: '', hasContractor: false, contractor: '', profile: this.profile._id });
    this.addRowCtrls(this.templates.length - 1);
  }

  get items(): FormArray {
    return this.form.get('items') as FormArray;
  }

  addRowCtrls(i: number, template?: any) {
    if (this.items.length <= i) {
      //console.log("has contractor new", i, template && template, template && template.contractor ? template.contractor.name.length > 0 : false);
      this.items.push(this.formBuilder.group({
        selection: [false, []],
        name: [template ? template.name : "", []],
        description: [template ? template.description : "", []],
        type: [template ? template.type : "", []],
        room: [template ? template.room : "", []],
        hasContractor: new FormControl(template && template.contractor ? template.contractor.name.length > 0 : false),
        contractor: [template && template.contractor ? this.formatContractor(template.contractor) : "", []]
      }));

    } else {
      //console.log("has contractor reuse", i, template && template, template && template.contractor ? template.contractor.name.length > 0 : false);
      ['name', 'description', 'type', 'room'].forEach(x => {
        this.items.at(i).get(x).setValue(template ? template[x] : "");
      });
      this.items.at(i).get('contractor').setValue(template && template.contractor ? this.formatContractor(template.contractor) : "");
      this.items.at(i).get('hasContractor').setValue(template && template.contractor ? template.contractor.name.length > 0 : false);

    }

    this.filteredTypes[i] = this.items.at(i).get('type').valueChanges.pipe(
      startWith(null),
      map((val: string) => val && val.length >= 1 ? this.typeAutocompleteFilter(this.allRooms, val) : this.allTypes.slice(0, 0)));

    this.filteredRooms[i] = this.items.at(i).get('room').valueChanges.pipe(
      startWith(null),
      map((val: string) => val && val.length >= 1 ? this.roomAutocompleteFilter(this.allRooms, val) : this.allRooms.slice(0, 0)));

    this.filteredContractors[i] = this.items.at(i).get('contractor').valueChanges.pipe(
      startWith(null),
      map((val: string) => val && val.length >= 1 ? this.contractorAutocompleteFilter(this.allContractors, val) : this.allContractors.slice(0, 0)));
  }

  selectAll() {
    let select = !this.form.get('allSelected').value;
    console.log("select all", select);
    this.templates.forEach((x, i) => {
      this.items.at(i).get('selection').setValue(select);
    });
  }

  populateTable() {

    this._pidService.getRoomsFromOwner(this._user.me()['_id']).subscribe((data: any) => {
      var allRooms = new Set();
      data.forEach(pid => pid.rooms.forEach(room => {
        allRooms.add(room);
      }));
      this.allRooms = [...allRooms].sort();

      this._contractorService.getMine()
        .subscribe(
          (contractors: any) => {
            contractors = contractors.filter(x => !x.shared).filter(x => !x.hidden).sort(function (a, b) {
              if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
              if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
              return 0;
            });
            this.allContractors = contractors;

            this._templateService.getMine()
              .subscribe(
                (templates: any) => {
                  templates.sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                  });
                  templates.forEach((x, i) => {
                    x.deleted = false;
                    x.hidden = false;
                    x.changed = false;
                    this.addRowCtrls(i, x);
                  });
                  this.templates = templates;

                  if (this.currentFilter) {
                    this.filterTemplates(this.currentFilter);
                  }

                  if (!this.pid) {
                    this.addTemplate();
                  }
                },
                this._notification.errorServer
              );
          },
          this._notification.errorServer
        );
    });
  }
}

